(function () {
  'use strict';

  var SHELL_SELECTOR = '[data-nom-cart]';
  var SUBSCRIPTION_SELECTOR = '[data-nom-cart-subscription-upsell]';
  var RECHARGE_APP_ID = '294517';
  var DEFAULT_DISCOUNT = 20;
  var productCache = {};
  var offerCache = {};
  var renderToken = 0;
  var switchInProgress = false;
  var itemsObserver = null;
  var lastCart = null;

  function normalizeRoot(root) {
    return root && root.slice(-1) === '/' ? root : (root || '/') + '/';
  }

  function rootPath() {
    return normalizeRoot(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function fetchCart() {
    return fetch(rootPath() + 'cart.js', {
      credentials: 'same-origin',
      headers: {Accept: 'application/json'}
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart.');
      return response.json();
    });
  }

  function customCartIsBusy() {
    return switchInProgress || !!(
      window.NomSiteCart &&
      typeof window.NomSiteCart.isBusy === 'function' &&
      window.NomSiteCart.isBusy()
    );
  }

  function setSwitchInProgress(isBusy) {
    switchInProgress = !!isBusy;
    window.NomCartSubscriptionSwitching = switchInProgress;

    if (window.NomSiteCart && typeof window.NomSiteCart.setLoading === 'function') {
      window.NomSiteCart.setLoading(switchInProgress);
    }
  }

  function fetchProduct(handle) {
    handle = String(handle || '').trim();
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = fetch(rootPath() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: {Accept: 'application/json'}
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).catch(function () {
      return null;
    });

    return productCache[handle];
  }

  function getMarker(line) {
    var properties = line && line.properties ? line.properties : {};
    var bundle = String(properties._nom_bundle_builder || '').toLowerCase();
    var bundleGift = String(properties._nom_bundle_gift || '').toLowerCase();
    var rewardGift = String(properties._nom_cart_reward_gift || '').toLowerCase();

    if (bundleGift === 'true' || rewardGift === 'true') return 'gift';
    if (bundle === 'true') return 'bundle';
    return 'other';
  }

  function getGroup(product, groupId) {
    var groups = product && product.selling_plan_groups ? product.selling_plan_groups : [];
    return groups.find(function (group) {
      return String(group.id) === String(groupId);
    }) || null;
  }

  function getPlan(group, planId) {
    var plans = group && group.selling_plans ? group.selling_plans : [];
    return plans.find(function (plan) {
      return Number(plan.id) === Number(planId);
    }) || null;
  }

  function getPlanIntervalDays(group, plan) {
    var optionText = '';
    var options = plan && plan.options ? plan.options : [];

    if (Array.isArray(options)) {
      optionText = options.map(function (option) {
        return [option.name, option.value].join(' ');
      }).join(' ');
    }

    var text = [
      group && group.name ? group.name : '',
      plan && plan.name ? plan.name : '',
      optionText
    ].join(' ').toLowerCase();
    var match = text.match(/(\d+)\s*(day|week|month|year)s?/);

    if (match) {
      var count = Number(match[1]);
      var unit = match[2];

      if (unit === 'day') return count;
      if (unit === 'week') return count * 7;
      if (unit === 'month') return count * 30;
      if (unit === 'year') return count * 365;
    }

    if (text.indexOf('weekly') !== -1) return 7;
    if (text.indexOf('monthly') !== -1) return 30;
    if (text.indexOf('yearly') !== -1 || text.indexOf('annual') !== -1) return 365;

    return Number.MAX_SAFE_INTEGER;
  }

  function looksRecharge(group, plan) {
    var groupAppId = String(group && group.app_id ? group.app_id : '');
    var planName = String(plan && plan.name ? plan.name : '').toLowerCase();
    var groupName = String(group && group.name ? group.name : '').toLowerCase();

    return groupAppId.indexOf(RECHARGE_APP_ID) !== -1 ||
      planName.indexOf('subscription') !== -1 ||
      groupName.indexOf('subscription') !== -1 ||
      planName.indexOf('delivery every') !== -1;
  }

  function getSubscriptionOffer(line, product) {
    if (!line || line.selling_plan_allocation || getMarker(line) !== 'other') return null;

    var variants = product && product.variants ? product.variants : [];
    var variant = variants.find(function (item) {
      return Number(item.id) === Number(line.variant_id);
    });

    if (!variant || !variant.selling_plan_allocations) return null;

    var candidates = [];

    for (var index = 0; index < variant.selling_plan_allocations.length; index += 1) {
      var allocation = variant.selling_plan_allocations[index];
      var group = getGroup(product, allocation.selling_plan_group_id);
      var plan = getPlan(group, allocation.selling_plan_id);

      if (!plan || !looksRecharge(group, plan)) continue;

      var basePrice = Number(line.final_price || line.price || 0);
      var allocationPrice = Number(allocation.price || 0);
      var discount = 0;

      if (allocationPrice > 0 && allocationPrice < basePrice) {
        discount = Math.round((basePrice - allocationPrice) * 100 / basePrice);
      } else {
        discount = DEFAULT_DISCOUNT;
      }

      if (discount > 0) {
        candidates.push({
          id: Number(plan.id || allocation.selling_plan_id),
          name: plan.name || group.name || 'Subscription',
          discount: discount,
          intervalDays: getPlanIntervalDays(group, plan),
          originalIndex: index
        });
      }
    }

    if (!candidates.length) return null;

    candidates.sort(function (left, right) {
      if (left.intervalDays !== right.intervalDays) return left.intervalDays - right.intervalDays;
      if (left.discount !== right.discount) return right.discount - left.discount;
      return left.originalIndex - right.originalIndex;
    });

    return candidates[0];
  }

  function getOfferCacheKey(line) {
    if (!line || !line.handle || !line.variant_id) return '';

    return [
      String(line.handle),
      String(line.variant_id),
      String(line.final_price || line.price || 0)
    ].join(':');
  }

  function hasCachedOffer(line) {
    var key = getOfferCacheKey(line);
    return !!key && Object.prototype.hasOwnProperty.call(offerCache, key);
  }

  function getCachedOffer(line) {
    var key = getOfferCacheKey(line);
    return key ? offerCache[key] : null;
  }

  function setCachedOffer(line, offer) {
    var key = getOfferCacheKey(line);
    if (key) offerCache[key] = offer || null;
  }

  function findLineElement(shell, lineKey) {
    var items = shell.querySelectorAll('.nom-site-cart__item[data-line-key]');

    for (var index = 0; index < items.length; index += 1) {
      if (items[index].getAttribute('data-line-key') === lineKey) {
        return items[index];
      }
    }

    return null;
  }

  function addSubscriptionUpsell(article, line, lineIndex, offer) {
    if (article.querySelector(SUBSCRIPTION_SELECTOR)) return;

    var controls = article.querySelector('.nom-site-cart__item-controls');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'nom-site-cart__subscription-upsell';
    button.setAttribute('data-nom-cart-subscription-upsell', '');
    button.setAttribute('data-line-index', String(lineIndex));
    button.setAttribute('data-line-key', line.key || '');
    button.setAttribute('data-quantity', String(line.quantity || 1));
    button.setAttribute('data-selling-plan', String(offer.id));
    button.setAttribute('data-variant-id', String(line.variant_id || ''));
    button.setAttribute(
      'aria-label',
      'Switch ' + (line.product_title || line.title || 'item') + ' to subscription and save ' + offer.discount + '%'
    );
    button.innerHTML = [
      '<span class="nom-site-cart__subscription-upsell-check" aria-hidden="true"></span>',
      '<span class="nom-site-cart__subscription-upsell-copy">',
      '<span class="nom-site-cart__subscription-upsell-title">Subscribe <span class="nom-site-cart__subscription-upsell-save">&amp; save ',
      escapeHtml(offer.discount),
      '%</span></span>',
      '</span>'
    ].join('');

    if (controls && controls.parentNode) {
      controls.parentNode.insertBefore(button, controls);
    } else {
      article.appendChild(button);
    }
  }

  function applyLineDecoration(shell, line, lineIndex, offer) {
    var article = findLineElement(shell, line.key || '');
    if (!article) return false;

    if (line.selling_plan_allocation) {
      article.classList.add('nom-site-cart__item--subscription');
      return true;
    }

    if (offer) {
      addSubscriptionUpsell(article, line, lineIndex, offer);
      return true;
    }

    return false;
  }

  function observeCartItems(shell) {
    var items = shell && shell.querySelector('[data-nom-cart-items]');

    if (!items || itemsObserver || typeof MutationObserver !== 'function') return;

    itemsObserver = new MutationObserver(function (mutations) {
      var shouldDecorate = mutations.some(function (mutation) {
        return mutation.type === 'childList' && mutation.addedNodes.length;
      });

      if (shouldDecorate && lastCart) {
        decorate(lastCart);
      }
    });

    itemsObserver.observe(items, {
      childList: true
    });
  }

  function decorate(cart) {
    var shell = document.querySelector(SHELL_SELECTOR);
    if (!shell || !cart || !cart.items) return;

    lastCart = cart;
    observeCartItems(shell);

    var token = ++renderToken;
    var tasks = cart.items.map(function (line, index) {
      if (line.selling_plan_allocation) {
        applyLineDecoration(shell, line, index + 1, null);
        return Promise.resolve();
      }

      if (hasCachedOffer(line)) {
        applyLineDecoration(shell, line, index + 1, getCachedOffer(line));
        return Promise.resolve();
      }

      return fetchProduct(line.handle).then(function (product) {
        if (token !== renderToken) return;

        var offer = getSubscriptionOffer(line, product);
        setCachedOffer(line, offer);

        if (offer) {
          applyLineDecoration(shell, line, index + 1, offer);
        }
      });
    });

    Promise.all(tasks).catch(function (error) {
      console.error(error);
    });
  }

  function scheduleDecorate(cart) {
    if (cart) {
      lastCart = cart;
      decorate(cart);
    }
  }

  function changeLineToSubscription(button) {
    var originalLine = Number(button.getAttribute('data-line-index') || 0);
    var lineKey = String(button.getAttribute('data-line-key') || '');
    var variantId = Number(button.getAttribute('data-variant-id') || 0);
    var sellingPlan = Number(button.getAttribute('data-selling-plan') || 0);

    if (!lineKey || !sellingPlan) {
      console.error(new Error('Missing subscription data.'));
      return Promise.resolve(null);
    }

    var refreshQueued = false;

    setSwitchInProgress(true);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    return fetchCart().then(function (cart) {
      var items = cart && cart.items ? cart.items : [];
      var lineIndex = items.findIndex(function (item) {
        return String(item.key || '') === lineKey;
      });
      var lineItem = lineIndex >= 0 ? items[lineIndex] : null;

      if (!lineItem && originalLine > 0 && items[originalLine - 1] && String(items[originalLine - 1].key || '') === lineKey) {
        lineIndex = originalLine - 1;
        lineItem = items[lineIndex];
      }

      if (!lineItem) throw new Error('Cart line changed before subscription switch.');
      if (variantId && Number(lineItem.variant_id) !== variantId) throw new Error('Cart line variant changed before subscription switch.');
      if (lineItem.selling_plan_allocation) return cart;

      return fetch(rootPath() + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line: lineIndex + 1,
          quantity: Number(lineItem.quantity || 1),
          selling_plan: sellingPlan
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to switch item to subscription.');
        return response.json();
      });
    }).then(function (cart) {
      if (window.NomSiteCart && typeof window.NomSiteCart.refresh === 'function') {
        refreshQueued = true;
        return window.NomSiteCart.refresh(false);
      }

      if (window.NomSiteCart && typeof window.NomSiteCart.setCart === 'function') {
        return window.NomSiteCart.setCart(cart);
      } else {
        scheduleDecorate(cart);
      }

      return cart;
    }).catch(function (error) {
      console.error(error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }).finally(function () {
      if (!refreshQueued) {
        setSwitchInProgress(false);
      } else {
        switchInProgress = false;
        window.NomCartSubscriptionSwitching = false;
      }
    });
  }

  document.addEventListener('nom:cart:updated', function (event) {
    scheduleDecorate(event.detail && event.detail.cart);
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(SUBSCRIPTION_SELECTOR) : null;
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (button.disabled || customCartIsBusy()) return;
    changeLineToSubscription(button);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(scheduleDecorate).catch(function () {});
  });
})();
